import { render, staticRenderFns } from "./check-contacter.vue?vue&type=template&id=d328f10c&"
import script from "./check-contacter.vue?vue&type=script&lang=js&"
export * from "./check-contacter.vue?vue&type=script&lang=js&"
import style0 from "./check-contacter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports